module.exports = __webpack_public_path__ + "static/media/innovation-mob-header@3x.2fd5b52d.png";